import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext<any>(null);

export const ChatProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeChatUserId, setActiveChatUserId] = useState<string | null>(null);

  return (
    <ChatContext.Provider value={{ activeChatUserId, setActiveChatUserId }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);
